<template>
    <div>
        <div class="content">
            <!-- BEGIN LOGIN FORM -->
            <form aria-label="Login" class="login-form">
                <div class="logo">
                    <a href="/public">
                        <img v-if="appLogo" :src="appLogo" :alt="project" class="logo-smart"
                             style="margin-top: -5px; margin-right: 5px; max-height:107px; max-width:300px;">
                        <span v-else>{{ project }}</span>
                    </a>
                </div>
                <h3 class="form-title font-green">Sign In</h3>
                <div class="alert alert-danger" :class="[ errors.email.length || errors.password.length ? 'display-show' : 'display-hide' ]">
                    <button class="close" type="button" @click="clearErrors(false)"></button>
                    <span>Email or Password is incorrect</span>
                </div>
                <div class="form-group">
                    <!--ie8, ie9 does not support html5 placeholder, so we just show field title for that-->
                    <label class="control-label visible-ie8 visible-ie9">Email</label>
                    <input class="form-control" :class="{'is-invalid': errors.email.length}" v-model="form.email"
                           type="email" placeholder="Email" name="email" @input="clearErrors('email')"
                           id="email" required autofocus>
                </div>
                <div class="form-group">
                    <label class="control-label visible-ie8 visible-ie9">Password</label>
                    <input class="form-control" :class="{'is-invalid': errors.password.length}" v-model="form.password"
                           type="password" placeholder="Password" name="password" @input="clearErrors('password')"
                           id="password" required>
                </div>
                <div class="form-actions">
                    <button @click.prevent="sendForm" type="button" class="btn green uppercase">Log In</button>
                    <label class="rememberme check">
                        <input v-model="form.remember" type="checkbox" name="remember" id="remember">Remember
                    </label>
                    <router-link v-if="hasPermission('page.login.btn-forgot-password')" :to="{ name: 'password-reset' }"
                                 id="forget-password" class="forget-password">Forgot Password?</router-link>
                </div>
                <div class="login-copyrights">
                    By logging in, you confirm your agreement to the <a target="_blank" href="https://smartyads.com/legal/cross-border-data-compliance-terms">Cross-Border Data Compliance Terms</a> and acknowledge that your personal data will be processed pursuant to our <a target="_blank" href="https://smartyads.com/services-privacy-policy">Services Privacy Policy</a>
                </div>

            </form>
            <!-- END LOGIN FORM -->
        </div>
        <div class="copyright">2011-{{ new Date().getFullYear() }} © {{ project }} {{ appType }}. All Rights Reserved </div>
    </div>
</template>

<script>

import r from "@/js/route";
import httpClient from '@/js/services/http-client';

export default {
    name: "Login",
    data: () => ({
        pending: false,
        form: {
            email: null,
            password: null,
            remember: false,
        },

        errors: {
            email: [],
            password: [],
        },

        project: import.meta.env.VITE_APP_NAME,
        appType: import.meta.env.VITE_APP_TYPE,
        appLogo: import.meta.env.VITE_APP_LOGO_HEADER,
        projectPermissions: []
    }),
    created() {
        this.getProjectPermissions();
    },
    methods: {
        sendForm() {
            if (this.pending === false) {
                this.pending = true;
                httpClient.post(r('login'), this.form)
                    .then(({ data }) => {
                        window.location.href = '/';
                    })
                    .catch(err => {
                        console.log(err.response.data.errors);

                        this.handleErrors(err.response.data.errors);
                    })
                    .then(() => {
                        this.pending = false;
                    });
            }
        },

        handleErrors(errors) {
            if (errors) {
                this.setErrors(errors)
            } else {
                this.clearErrors()
            }
        },

        setErrors(errors) {
            for (let key in this.errors) {
                if (Object.hasOwnProperty.call(this.errors, key)) {
                    this.errors[key] = errors[key] || []
                }
            }
        },

        clearErrors(key = false) {
            if (key) {
                if (this.errors[key].length) {
                    this.errors[key] = []
                }
            } else {
                for (let key in this.errors) {
                    if (Object.hasOwnProperty.call(this.errors, key)) {
                        this.errors[key] = []
                    }
                }
            }
        },
        getProjectPermissions() {
            this.$root.countRequests++;

            httpClient.get(r('project.permissions.list'))
                .then(({data}) => {
                    this.projectPermissions = data
                })
                .catch(() => {
                    this.projectPermissions = [];
                })
                .finally(() => {
                    this.$root.countRequests--;
                });
        },

        hasPermission(key) {
            return this.projectPermissions.includes(key)
        }
    }
}
</script>

<style lang="scss" scoped>
@use "@/sass/views/auth/login" as *;
</style>
